import { Box, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { BsFileEarmarkArrowDown } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'
import Catalog from '../../../../../../api/db/Catalog'
import { IAddFormProps } from '../../../../../../shared/types'
import { selectCurrrentAdminShop } from '../../../../../../store/features/currentBusinessShop'
import { selectUserPropsState } from '../../../../../../store/features/user'
import { ValidatedButton, ValidatedForm, ValidatedTextInput } from '../../../../../organisms/validation/admin'

const initialValues= {
    start_date: "",
    end_date: ""
}
  
  
const validationSchema = Yup.object().shape({
    start_date: Yup.string().required().label("start_date"),
    end_date: Yup.string().required().label("end_date")
})

export default function ExportProductCategoriesForm({onDone, onFail}:IAddFormProps) {

    const [isLoading, setIsLoading] = useState(false)
    const user_id = useSelector(selectUserPropsState)?.uid
    const current_shop = useSelector(selectCurrrentAdminShop)?.name


    const handleOnSubmit = async ({start_date, end_date}:{start_date: Date, end_date: Date})=>{

        const _start_date = new Date(start_date)
        const _end_date = new Date(end_date)

        if(_end_date < _start_date){
            onFail("Invalid date range")
            return
        }

        try {

            setIsLoading(true)
            const categories = await Catalog.getCategoriesByDateRange(_start_date, _end_date, user_id, current_shop)
            setIsLoading(false)
            onDone(categories)
            
        } catch (error) {
            setIsLoading(false)
            onFail(error)
        }
        
    }
    
  return (
    <ValidatedForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleOnSubmit}
    >

        <Box
        >
            <Stack 
                direction="row"
                sx={{width: "100%", marginBottom: "1rem"}}
                spacing={2}
            >
                <Stack sx={{width: "100%"}}>
                    <Typography variant="subtitle2" color="grey.500">Start Date:</Typography>
                    <ValidatedTextInput 
                        type="date"
                        name="start_date"
                    />
                </Stack>
                <Stack sx={{width: "100%"}}>
                    <Typography variant="subtitle2" color="grey.500">End Date:</Typography>
                    <ValidatedTextInput 
                        type="date"
                        name="end_date"
                    />
                </Stack>
            </Stack>

            <Box
                sx={{marginTop: "1.5rem", display: "flex", justifyContent: "flex-end"}}
            >
                
                <ValidatedButton
                    startIcon={<BsFileEarmarkArrowDown />} 
                    variant="contained" 
                    color="secondary" 
                    disableElevation={true}
                    loading={isLoading}
                >
                    <Typography  color="primary" sx={{fontSize: "13px"}} >Download</Typography>
                </ValidatedButton>
            </Box>

        </Box>
        
    </ValidatedForm>
  )
}
